export class NotificationModel {
  type: number;
  messenger: string;
  title: string;
  error: number;
  configNotification: any;
}
